/**
 * Postmark sender wait-state labels — mirrors classifySenderWaitState
 * in functions-forms/src/email/customDomains.ts (4478cfa).
 */

export const SENDER_HELPER_COPY =
  'This is the name and address your leads see. It should match the person or team who signs the emails.';

export const SENDER_WAIT_LABELS = {
  dns: 'Awaiting DNS',
  email_confirmation: 'Awaiting email confirmation',
  none: 'Ready',
};

/**
 * @param {{ verificationStatus?: string, waitingOn?: string }} sender
 * @returns {'dns' | 'email_confirmation' | 'none'}
 */
export function senderWaitingOn(sender) {
  if (!sender) return 'dns';
  if (sender.verificationStatus === 'verified' || sender.waitingOn === 'none') return 'none';
  if (sender.waitingOn === 'email_confirmation') return 'email_confirmation';
  return 'dns';
}

export function senderWaitLabel(sender) {
  return SENDER_WAIT_LABELS[senderWaitingOn(sender)] || SENDER_WAIT_LABELS.dns;
}
